export const Keywords = () => {
  const keywords = [
    // Core Web
    "JavaScript",
    "TypeScript",
    "HTML",
    "CSS",

    // Frontend Frameworks & State
    "React",
    "Next.js",
    "Redux Toolkit",

    // Styling & UI Systems
    "Tailwind CSS",
    "Ant Design",
    "shadcn/ui",
    "Headless UI",

    // APIs & Data
    "REST APIs",
    "API Integration",
    "GraphQL",

    // Auth & Backend Services (Frontend Usage)
    "Firebase",
    "Auth0",

    // Realtime & Maps
    "Socket.IO",
    "Google Maps API",

    // Architecture & Practices
    "Component Architecture",
    "State Management",
    "Object-Oriented Programming (OOP)",

    // Tooling & AI
    "OpenAI API",

    // Core Strength
    "Problem Solving",
  ];

  return (
    <>
      <div className="text-[30px] font-[600] mt-3">Keywords</div>
      <div className="flex flex-wrap justify-center sm:justify-start gap-2">
        {keywords.map((keyword) => {
          return (
            <div>
              <div className="p-2 py-1 text-[12px] border border-tag bg-body rounded-full text-center bg-secondary-hover">
                {keyword}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
